import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService } from '../../../core/services/customer.service';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { FilesService } from '../../../core/services/files.service';
import { PageSize } from '../../../core/dto/page.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Pagination } from '../../../core/dto/pagination';

const NOTES_AND_ATTACHMENT_UPLOAD = 'NOTES_AND_ATTACHMENT_UPLOAD';

@Component({
  selector: 'app-view-single-customer',
  templateUrl: './view-single-customer.component.html',
  styleUrls: ['./view-single-customer.component.scss'],
})
export class ViewSingleCustomerComponent implements OnInit {
  activeTabIndex = 0;
  breadcrumbs: any[] = [];
  customerId: any;
  loading = false;
  loadingTable = false;
  inputValue = '';
  tempInputVal = '';
  files: any[] = [];
  isVisible = false;
  status = 'create';
  uploading = false;
  searchText: any;
  statusFilter: any;
  dateFilter: any;
  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;
  bookingData: any[] = [];
  contryData: any;

  customerData = {
    _id: '',
    customerId: '',
    renterDetails: {
      title: '',
      fullName: '',
      contactNo: '',
      email: '',
      homeAddress: '',
      homeCountry: '',
      otherCountry: '',
      dob: '',
      birthCity: '',
      birthCountry: '',
      dailCode: '',
    },
    passportLicenceDetails: {
      passportNo: '',
      issueDatePass: '',
      expiryDatePass: '',
      drivingLicenceNo: '',
      issueDateLicence: '',
      expiryDateLicence: '',
      issuedCountryLicence: '',
    },
    notesAndAttachments: {
      notes: '',
      attachments: [{ name: '', url: '' }],
    },
    passportLicenceFiles: [{ name: '', url: '' }],
  };

  skeletonTableColumns: any[] = [
    'Booking ID',
    'Booking Type',
    'Driver Name',
    'Booking Start Date and Time',
    'Booking End Date and Time',
    'Booking Status',
    'Vehicle Reg Number',
    'Agent',
    'Agent Booking Reference',
  ];

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private filesService: FilesService,
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.customerId = this.route.snapshot.paramMap.get('id');
    this.fetchCountryCodeList();
    this.customerService.getCustomerById(this.customerId).subscribe(
      (res) => {
        this.customerData = res;
        console.log(res);
        this.inputValue = res.notesAndAttachments.note;
        this.tempInputVal = res.notesAndAttachments.note;
        this.files = res.notesAndAttachments.attachments;
        this.setBreadcrumbs();
        this.loading = false;
      },
      (e: any) => {
        this.loading = false;
        this.message.create('error', 'Error');
      },
    );
  }

  fetchCountryCodeList() {
    this.customerService.fetchJsonData().subscribe((data) => {
      this.contryData = data;
    });
  }
  selectedDailNumber(event: any) {
    const contry = this.contryData.find((value: any) => value.code === event);
    return contry.dial_code;
  }

  selectedTitle(title: string) {
    let value;
    switch (title) {
      case 'MR':
        value = 'Mr.';
        break;
      case 'MRS':
        value = 'Mrs.';
        break;
      case 'MISS':
        value = 'Miss';
        break;
    }
    return value;
  }
  setBreadcrumbs(): void {
    this.breadcrumbs = [
      {
        title: ` Customer `,
        route: '/admin/customers',
        icon: 'delivered-procedure',
      },
      {
        title: ` ${this.customerData.customerId} `,
      },
    ];
  }

  editNavigate(): void {
    const navigationExtras = {
      queryParams: {
        prev: 'single', // Replace 'your_value_here' with the actual value you want to pass
      },
    };
    this.router.navigate(
      [`admin/customers/add-edit/${this.customerId}`],
      navigationExtras,
    );
  }

  upload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, NOTES_AND_ATTACHMENT_UPLOAD)
      .subscribe((res) => {
        this.filesService.fileUploadingSubject.next({
          type: NOTES_AND_ATTACHMENT_UPLOAD,
          loading: false,
        });
        // this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.files.push({ name: item.file.name, url: data.url });
        // this.uploadPointer = true;
        this.postData('upload', 'attachment_update');
      });

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.inputValue = this.tempInputVal;
    this.postData('notes', 'note_update');
    this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  postData(type: string, updateType: string) {
    this.loading = true;
    if (this.status === 'create') {
      this.customerService
        .updateCustomer({
          _id: this.customerData._id,
          notesAndAttachments: {
            note: this.inputValue,
            attachments: this.files,
          },
          updateType: updateType,
        })
        .subscribe(
          () => {
            this.status = 'update';
            this.loading = false;
          },
          (e: any) => {
            this.loading = false;
            this.message.create('error', 'Error');
          },
        );
    } else if (this.status === 'update') {
      this.customerService
        .updateCustomer({
          _id: this.customerData._id,
          notesAndAttachments: {
            note: this.inputValue,
            attachments: this.files,
          },
          updateType: updateType,
        })
        .subscribe(
          () => {
            this.loading = false;
            if (type === 'notes') {
              this.message.create('success', `Notes has been updated!`);
            } else {
              this.message.create('success', `New attachment has been added!`);
            }
          },
          (e: any) => {
            this.loading = false;
            this.message.create('error', 'Error');
          },
        );
    }
  }

  confirmRemoveAttachment(attachmentId: any): void {
    this.files.splice(attachmentId, 1);
    this.loading = true;
    this.customerService
      .updateCustomer({
        _id: this.customerData._id,
        notesAndAttachments: {
          attachments: this.files,
        },
        updateType: 'attachment_delete',
      })
      .subscribe(
        () => {
          this.loading = false;
          this.message.create('success', `Attachment has been deleted!`);
        },
        (e: any) => {
          this.loading = false;
          this.message.create('error', 'Error');
        },
      );
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedBookings();
  }

  onChangeDateFilter(result: Date[]): void {
    this.getPagedBookings();
  }

  resetSearch() {
    this.searchText = null;
    this.statusFilter = null;
    this.dateFilter = null;
    this.getPagedBookings();
  }

  search() {
    this.getPagedBookings();
  }

  getPagedBookings(): void {
    this.loadingTable = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        searchValue: this.searchText,
        status: this.statusFilter,
        dateFilter: this.dateFilter,
      },
      id: this.route.snapshot.paramMap.get('id'),
    });
    console.log(payload);
    this.customerService.getCustomerBookings(payload).subscribe(
      (res: any) => {
        this.loadingTable = false;
        this.bookingData = res.bookings;
        console.log(res.bookings);
        this.pageSize.length = res.totalItems;
      },
      (e: any) => {
        this.loadingTable = false;
        this.message.create('error', 'Error');
      },
    );
  }

  navigate(data: any): void {
    if (data.bookingType === 'rent') {
      this.router.navigate([`/admin/booking-rent/${data._id}`]);
    } else {
      this.router.navigate([`admin/booking-transfer/${data._id}`]);
    }
  }
}
